export interface ClimateRiskScoreItem {
  index: string;
  scenario?: string;
}

export const FATHOM_LAYER_IDS = [
  "FL_Fluvial_Global_Fathom",
  "FL_Pluvial_Global_Fathom",
  "FL_Coastal_Global_Fathom"
];

const CLIMATE_SCENARIOS = ["SSP1-2.6", "SSP2-4.5", "SSP3-7.0", "SSP5-8.5"];

export const CRS_RESPONSE_STRUCTURE = "{2030,2035,2040,2045,2050,2055,2060,2070,2085}";

export const isFathomLayer = (layerId: string) => FATHOM_LAYER_IDS.includes(layerId);

export const filterFathomLayers = (layers: string[]) => layers.filter(isFathomLayer);

export const filterNonFathomLayers = (layers: string[]) =>
  layers.filter((layerId) => !isFathomLayer(layerId));

export const buildClimateRiskScores = (layerIds: string[]): ClimateRiskScoreItem[] => {
  const scores: ClimateRiskScoreItem[] = [];

  CLIMATE_SCENARIOS.forEach((scenario) => {
    layerIds.forEach((index) => {
      if (!(index === "drought_old" && scenario === "SSP3-7.0")) {
        scores.push({ index, scenario });
      }
    });
  });

  return scores;
};

export const buildFutureHazardRiskScores = (layerIds: string[]): ClimateRiskScoreItem[] => {
  const scores: ClimateRiskScoreItem[] = [];

  CLIMATE_SCENARIOS.forEach((scenario) => {
    layerIds.forEach((index) => {
      scores.push({ index, scenario });
    });
  });

  return scores;
};

export const buildCrsComponentRiskScores = (layerIds: string[]): ClimateRiskScoreItem[] => {
  const scores: ClimateRiskScoreItem[] = [];

  CLIMATE_SCENARIOS.forEach((scenario) => {
    layerIds.forEach((index) => {
      scores.push({ index, scenario });
    });
  });

  return scores;
};
